import { LOCAL_WIDGET_ID, WidgetTokenProvider } from '@elfsight/lib-utils';
import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import { PortalNestProvider } from '@elfsight/widget-modal';
import {
  CustomCSS,
  createCustomCSSPrefixClassName,
  EmbedRoot,
  useFontsLoader
} from '@elfsight/widget-ui';
import { meta } from './meta';
import type { LogoShowcaseSettings } from './types';
import { LogoProvider } from './widget/logo';
import { Widget } from './widget/Widget';

export const LogoShowcase = ({
  width,
  widgetId,
  widgetToken,
  editMode,
  customCSS,
  customJS,
  font,
  renderThumbnailMode
}: LogoShowcaseSettings) => {
  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.alias,
    widgetId
  );

  useDefineAPISchema();
  useFontsLoader([font]);
  useCustomJS(customJS, editMode || renderThumbnailMode);

  return (
    <WidgetTokenProvider
      widgetId={widgetId ?? LOCAL_WIDGET_ID}
      widgetToken={widgetToken}
    >
      <LogoProvider>
        <PortalNestProvider
          customCSSClassName={customCSSPrefixClassName}
          font={font}
        >
          <EmbedRoot
            customCSSClassName={customCSSPrefixClassName}
            font={font}
            width={width}
          >
            <Widget />
            <CustomCSS
              customCSS={customCSS}
              prefixClassName={customCSSPrefixClassName}
            />
          </EmbedRoot>
        </PortalNestProvider>
      </LogoProvider>
    </WidgetTokenProvider>
  );
};
